export const AssignmentSearchTypes = {
    MINE: 1,
    SHARED: 2,
    ORGANIZATION: 3,
}

export const getAssignmentSearchTypeName = (type) => {
    switch (type) {
        case AssignmentSearchTypes.MINE:
            return 'Owned by Me'
        case AssignmentSearchTypes.SHARED:
            return 'Shared with Me'
        case AssignmentSearchTypes.ORGANIZATION:
            return 'All'
        default:
            return 'Unknown'
    }
} 